import { createSelector } from 'reselect';
import { find, get } from 'lodash/fp';
import { createAction } from '@mews/framework';
import { RegistrationCardConfiguration, ApplicationState } from '@mews-commander/types';
import { getStringProp } from '@mews/fp';
import parentSelector from '../selector';
import prefix from '../prefix';
import { createBaseEntitySelectors, createEntitiesReducer } from './utils';

export const NAME = 'registrationCardConfigurations';
const REGISTRATION_CARD_CONFIGURATIONS_LOADED = prefix('REGISTRATION_CARD_CONFIGURATIONS_LOADED');

export const setRegistrationCardConfigurations = (configurations: RegistrationCardConfiguration[]) =>
    createAction(REGISTRATION_CARD_CONFIGURATIONS_LOADED, { entities: configurations });

export const registrationCardConfigurationsReducer = createEntitiesReducer({
    FETCH_SUCCESS: REGISTRATION_CARD_CONFIGURATIONS_LOADED,
});
export const [getRegistrationCardConfigurations] = createBaseEntitySelectors<
    ApplicationState,
    RegistrationCardConfiguration,
    typeof NAME
>(parentSelector, NAME);

export const getRegistrationCardConfigurationByServiceId = createSelector(
    getStringProp('serviceId'),
    getRegistrationCardConfigurations,
    (serviceId, configurations) => find({ serviceId }, configurations)
);
export const getPageFormatByServiceId = createSelector(getRegistrationCardConfigurationByServiceId, get('format'));
